import { Clock } from "lucide-react";

// Centered footer with the build timestamp, so you can tell at a glance
// whether prod is serving the deploy you just shipped.
// Value is injected at build time (see vite.config.ts -> define).

const BUILD_DATE = typeof __APP_BUILD_DATE__ !== "undefined" ? __APP_BUILD_DATE__ : "";

function formatDate(iso: string): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "America/Sao_Paulo",
  }).format(d).replace(".", "");
}

export function BuildInfo({ className = "" }: { className?: string }) {
  return (
    <div
      className={`flex items-center justify-center gap-1.5 text-[11px] tracking-wide text-muted-foreground/60 ${className}`}
    >
      <Clock className="h-3 w-3" aria-hidden="true" />
      <span className="tabular-nums">Última atualização: {formatDate(BUILD_DATE)}</span>
    </div>
  );
}
